import React from 'react';
import PropTypes from 'prop-types';

import TextField from '@mui/material/TextField';
import {FormControl, FormHelperText, IconButton, InputAdornment, Tooltip} from '@mui/material';
import { withStyles } from '@mui/styles';

import { NumericFormat } from 'react-number-format';
import {TimestampHelperButtons} from './TimestampHelperButtons';


const styles = {
	formControl: {
		marginTop: 4,
	},
	tooltip: {
		whiteSpace: 'pre-line',
	}
};

function isInteger(values) { // values.value is numeric string
	return !values.value.includes('.');
}

function CompactTextField(props) {
	let helperText = (props.error ? props.errorText || props.helperText : props.helperText) || '';
	let textFieldProps = {
		...(props.TextFieldProps || {}),
		value: props.value,
		defaultValue: props.defaultValue,
		onChange: props.onChange,
		id: props.id,
		label: props.label,
		multiline: props.multiline || false,
		minRows: props.multiline === true && props.rows ? props.rows : '1',
		margin: 'dense',
		variant: 'outlined',
		fullWidth: true,
		onKeyDown: props.onKeyDown,
		required: props.required || false,
		inputProps: {
			style: { boxSizing: 'border-box', padding: '8px 10px', height: (props.multiline ? 'auto' : '36px'), },
		},
		InputProps: {
			endAdornment: <TimestampHelperButtons onChange={(value) => props.onChange({ target: { value }})} label={props.label} />
		},
		InputLabelProps: {
			shrink: true,
		},
		error: props.error,
		disabled: props.readOnly || false,
	};
	return (
		<FormControl fullWidth className={props.classes.formControl}>
			<Tooltip title={helperText && <div className={props.classes.tooltip} dangerouslySetInnerHTML={{ __html: helperText }} />}>
				{props.type === 'number' || props.type === 'integer' ?
					<div>
						<NumericFormat
							customInput={TextField}
							valueIsNumericString
							isAllowed={props.type === 'integer' ? isInteger : undefined}

							{...textFieldProps}
						/>
					</div> :
					<TextField
						type={props.type || 'text'}
						{...textFieldProps}
					/>}
			</Tooltip>
			{helperText && <FormHelperText>{new DOMParser().parseFromString(helperText, 'text/html').body.textContent || ''}</FormHelperText>}
		</FormControl>
	);
}

CompactTextField.propTypes = {
	type: PropTypes.string,
	value: PropTypes.string,
	defaultValue: PropTypes.string,
	required: PropTypes.bool,
	helperText: PropTypes.string,

	id: PropTypes.string,
	label: PropTypes.string,
	multiline: PropTypes.bool,
	rows: PropTypes.number,

	onChange: PropTypes.func,
	onKeyDown: PropTypes.func,

	error: PropTypes.bool,
	errorText: PropTypes.string,

	readOnly: PropTypes.bool,

	TextFieldProps: PropTypes.object,

	classes: PropTypes.object,
};

export default withStyles(styles)(CompactTextField);